module.exports = __webpack_public_path__ + "static/media/crown.60410ba2.svg";